import getTag from './internals/getTag.js';
import { blobTag, stringUndefined } from './internals/native.js';

var blobExisted = typeof Blob !== stringUndefined;
function isBlob(value) {
    if (blobExisted && value instanceof Blob) {
        return true;
    }
    return getTag(value) === blobTag;
}

export { isBlob as default };
